import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { useGoodsSno } from '../hooks/useGoodsSno';
import { useFixedCouponSno } from '../hooks/useFixedCouponSno';
import { queryKey } from '../constant/queryKey';

export const useGoodsCoupon = () => {
  const goodsSno = useGoodsSno();
  const fixedCouponSno = useFixedCouponSno();
  return useQuery({
    queryKey: queryKey.goodsCoupon(goodsSno, fixedCouponSno),
    queryFn: () => goodsService.getGoodsCoupon(goodsSno, fixedCouponSno),
  });
};
